import { render, staticRenderFns } from "./peopleModel.vue?vue&type=template&id=f18f2dda&scoped=true"
import script from "./peopleModel.vue?vue&type=script&lang=js"
export * from "./peopleModel.vue?vue&type=script&lang=js"
import style0 from "./peopleModel.vue?vue&type=style&index=0&id=f18f2dda&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18f2dda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f18f2dda')) {
      api.createRecord('f18f2dda', component.options)
    } else {
      api.reload('f18f2dda', component.options)
    }
    module.hot.accept("./peopleModel.vue?vue&type=template&id=f18f2dda&scoped=true", function () {
      api.rerender('f18f2dda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examine/auditManage/peopleModel.vue"
export default component.exports